module.exports = __webpack_public_path__ + "static/media/pikto_inne.a16967b6.png";